export enum BankTransactionSortProperty {
  Amount = 'amount',
  EntryDate = 'entryDate',
}
